import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      isEditMode: state.isEditMode
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
